import React, { useEffect, useState } from 'react';
import {
  Grid,
  Card,
 
  Typography,
  Box,
  Stack,
} from '@mui/material';
import { TrendingUp, Group, EventNote, Hotel, Info } from '@mui/icons-material';

const StatisticsCards = () => {
  const [registeredPatientsCount, setRegisteredPatientsCount] = useState(0);
  const [opdRegisteredCount, setOpdRegisteredCount] = useState(0);
  const [ipdRegisteredCount, setIpdRegisteredCount] = useState(0);
  const [currentTime, setCurrentTime] = useState('');
  const [todayDate, setTodayDate] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      const date = new Date();
      setCurrentTime(date.toLocaleTimeString([], { hour12: false }));
    }, 1000);

    const date = new Date();
    setTodayDate(
      date.toLocaleDateString('en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    );

    setRegisteredPatientsCount(245);
    setOpdRegisteredCount(180);
    setIpdRegisteredCount(65);

    return () => clearInterval(interval);
  }, []);

  const cards = [
    {
      title: todayDate,
      value: currentTime,
      icon: <EventNote fontSize="large" />,
      gradient: 'linear-gradient(135deg, #81c784 0%, #388e3c 100%)',
    },
    {
      title: 'Total Patients Registered',
      value: registeredPatientsCount.toLocaleString(),
      icon: <TrendingUp fontSize="large" />,
      gradient: 'linear-gradient(135deg, #64b5f6 0%, #1976d2 100%)',
    },
    {
      title: 'OPD Patients',
      value: opdRegisteredCount.toLocaleString(),
      icon: <Group fontSize="large" />,
      gradient: 'linear-gradient(135deg, #ba68c8 0%, #7b1fa2 100%)',
    },
    {
      title: 'IPD Patients',
      value: ipdRegisteredCount.toLocaleString(),
      icon: <Hotel fontSize="large" />,
      gradient: 'linear-gradient(135deg, #e57373 0%, #d32f2f 100%)',
    },
  ];

  return (
    <Grid
      container
      spacing={2}
      sx={{ mt: 1, height: '100%' }}
      alignItems="stretch"
    >
      {/* Cards section (left 9/12) */}
      <Grid item xs={12} md={9}>
        <Grid container spacing={2}>
          {cards.map((card, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Long card (right 3/12) */}
      <Grid item xs={12} mt={-2} sx={{ display: 'flex' }}>
        <Card
          sx={{
            width: '100%',
            background: 'linear-gradient(135deg,rgb(38, 30, 3) 0%,rgb(53, 45, 26) 100%)',
            color: '#333',
            borderRadius: 3,
            boxShadow: 4,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            p: 2,
          }}
        >
          <Stack spacing={2}>
            <Box display="flex" alignItems="center" gap={1}>
  <Info sx={{ color: 'white' }} /> {/* Make icon white */}
  <Typography variant="h6" fontWeight={600} sx={{ color: 'white' }}>
    Hello, Team..
  </Typography>
</Box>
<Typography 
  variant="body1"  // Changed from body2 to body1 for larger size
  sx={{ 
    color: 'white', 
    fontWeight: 600,  // Better than 'bold' for precision
    fontSize: '1rem', // Explicit size
    lineHeight: 1.6,  // Better readability
    textShadow: '0 1px 2px rgba(0,0,0,0.3)' // Anti-aliasing for light text
  }}
>
 Excellence is a habit, not a one-time act. Uphold integrity by doing the right thing even when no one is watching. With unwavering focus, honesty, and drive, Dedication will shape the success we achieve together.
</Typography>
          </Stack>
        </Card>
      </Grid>
    </Grid>
  );
};

export default StatisticsCards;
